import { Controller } from "@hotwired/stimulus";
import { i18n } from "../lib/i18n";

// Text expansion controller for long text fields in tables
// Shows truncated text with "Show more" option
//
// Usage:
//   <div data-controller="text-expand"
//        data-text-expand-full-text-value="Full text content here"
//        data-text-expand-truncate-length-value="100">
//     <span data-text-expand-target="content">Truncated tex...</span>
//     <button data-text-expand-target="toggle" data-action="click->text-expand#toggle">
//       Show more
//     </button>
//   </div>
export default class extends Controller {
  static targets = ["content", "toggle"];
  static values = {
    fullText: String,
    truncateLength: { type: Number, default: 100 },
    expanded: { type: Boolean, default: false }
  };

  connect() {
    this.updateDisplay();
  }

  toggle() {
    this.expandedValue = !this.expandedValue;
    this.updateDisplay();
  }

  updateDisplay() {
    const fullText = this.fullTextValue || "";
    const truncateLength = this.truncateLengthValue;

    if (fullText.length <= truncateLength) {
      // Text is short enough, no truncation needed
      this.contentTarget.textContent = fullText;
      if (this.hasToggleTarget) {
        this.toggleTarget.classList.add("hidden");
      }
      return;
    }

    if (this.expandedValue) {
      // Show full text
      this.contentTarget.textContent = fullText;
      if (this.hasToggleTarget) {
        this.toggleTarget.textContent = i18n.t('text_expand.show_less');
        this.toggleTarget.classList.remove("hidden");
      }
    } else {
      // Show truncated text
      this.contentTarget.textContent =
        fullText.substring(0, truncateLength) + "...";
      if (this.hasToggleTarget) {
        this.toggleTarget.textContent = i18n.t('text_expand.show_more');
        this.toggleTarget.classList.remove("hidden");
      }
    }
  }
}
